/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import NProgress from 'nprogress'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import ReservationView from '../../view/pages/segmentation/ReservationView'
import SegmentCategoryOptionsStore from '../../store/reservation_segment/SegmentCategoryOptionsStore'
import ReservationSegmentsStore from '../../store/reservation_segment/ReservationSegmentsStore'
import ReservationSegmentAction from '../../action/reservation_segment'
import EditStore from '../../store/reservation_segment/EditStore'

class ReservationContainer extends Component {
  static getStores() {
    return [EditStore, SegmentCategoryOptionsStore, ReservationSegmentsStore]
  }

  static calculateState(prevState, props) {
    return {
      edit: EditStore.getState(),
      segment_category_options: SegmentCategoryOptionsStore.getState(),
      reservation_segments: ReservationSegmentsStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    const reservation_id = this.state.match.params.id
    if (reservation_id) {
      ReservationSegmentAction.fetch(reservation_id)
    }
    NProgress.done()
  }

  render() {
    return ReservationView(this.state)
  }
}

export default withRouter(Container.create(ReservationContainer, { withProps: true }))
